import { LEDGER_ENTRY_TYPE } from 'Data/payments.js'

export function getView(entry) {
  return [
    LEDGER_ENTRY_TYPE.PAYMENT_CORRECTION,
    LEDGER_ENTRY_TYPE.REFUND,
    LEDGER_ENTRY_TYPE.TRANSFER_CREDIT,
  ].includes(entry.type)
}
